<template>
  <div class="card project-page__documents">
    <h2 class="card__title">
      {{ $t('project_documents.title') }}
    </h2>

    <PagesProjectDocument
      v-for="document in documents"
      :key="document.id"
      :document="document"
    />
  </div>
</template>

<script setup>
defineProps({
  documents: {
    type: Array,
    required: true,
  },
});
</script>
